<template>
    <div>
        <v-fade-transition>
            <v-card v-if="viewReportsModal" class="view-reports-modal" elevation="6">
                <v-card-title>
                    <h2>{{ t('quality-control::nequas.reports.modal.title') }}</h2>
                    <v-icon color="rgba(0,0,0,0.32)" size="24" @click="viewReportsModal = false">mdi-close</v-icon>
                </v-card-title>
                <v-card-text class="reports">
                    <div class="h-100">
                        <label v-if="reports && reports.data.length" class="label" for="date">{{
                            t('quality-control::nequas.label.date')
                        }}</label>
                        <div class="d-flex flex-column justify-content-between" style="height: 96%">
                            <v-list
                                v-if="reports && reports.data.length"
                                style="background-color: transparent !important"
                            >
                                <template v-for="(report, index) in reports.data">
                                    <div :key="index" class="report">
                                        <div class="report-wrap">
                                            <div class="copy">
                                                <div v-if="report.file_name" class="name">
                                                    {{ report.file_name }}
                                                </div>
                                            </div>
                                            <div class="actions">
                                                <v-tooltip
                                                    v-if="can('neqas-reports.download')"
                                                    top
                                                    transition="v-fab-transition"
                                                >
                                                    <template #activator="{ on, attrs }">
                                                        <v-btn
                                                            color="rgba(0,0,0,0.34)"
                                                            icon
                                                            v-bind="attrs"
                                                            small
                                                            v-on="on"
                                                            @click="downloadReport(report)"
                                                        >
                                                            <v-icon size="22">mdi-download</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>{{ t('quality-control::button.download_file') }}</span>
                                                </v-tooltip>
                                                <v-tooltip
                                                    v-if="can('api.v1.neqas-reports.show')"
                                                    top
                                                    transition="v-fab-transition"
                                                >
                                                    <template #activator="{ on, attrs }">
                                                        <v-btn
                                                            color="rgba(0,0,0,0.34)"
                                                            icon
                                                            v-bind="attrs"
                                                            small
                                                            v-on="on"
                                                            @click="previewReport(report)"
                                                        >
                                                            <v-icon size="22">mdi-eye</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>{{ t('quality-control::button.view') }}</span>
                                                </v-tooltip>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </v-list>
                            <v-list v-else class="h-100" style="background-color: transparent !important">
                                <v-list-item class="p-0">
                                    <v-list-item-title
                                        >{{ t('quality-control::nequas.reports.modal.no.data.text') }}
                                    </v-list-item-title></v-list-item
                                >
                            </v-list>
                            <div
                                v-if="reports && reports.meta && reports.meta.pagination"
                                v-show="reports.meta.pagination.total_items > 0"
                                class="pagination"
                            >
                                <v-pagination
                                    v-model="reports.meta.pagination.current_page"
                                    :length="reports.meta.pagination.total_pages"
                                    circle
                                    color="amber"
                                    total-visible="8"
                                    @input="fetchReportsList"
                                ></v-pagination>
                            </div>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-fade-transition>
        <v-dialog v-model="previewReportsModal" width="80%" @input="onClose">
            <v-card v-if="currentReport">
                <v-card-title class="mb-4 justify-content-between">
                    <div>
                        {{ t('quality-control::nequas.reports.modal.neqas_sample_report') }} -
                        <span v-if="currentReport && currentReport && currentReport.data.file_name"></span
                        >{{ currentReport.data.file_name }}
                    </div>
                    <div>
                        <v-btn
                            v-if="can('neqas-reports.download')"
                            rounded
                            text
                            color="primary"
                            class="mr-4"
                            @click="downloadReport(currentReport.data)"
                            >{{ t('quality-control::button.download_file') }}</v-btn
                        >
                        <v-icon color="#a5a5a5" @click="previewReportsModal = false">mdi-close</v-icon>
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-tabs v-model="tab" show-arrows class="mt-1">
                        <v-tab v-for="(item, index) in items" :key="index">
                            <div class="tab">
                                {{ item }}
                            </div>
                        </v-tab>

                        <v-tab-item v-for="(item, index) in items" :key="item + index">
                            <div class="neqas-modal-table">
                                <neqas-sample-report-table
                                    :columns="columns"
                                    :items="gridItems"
                                ></neqas-sample-report-table>
                            </div>
                        </v-tab-item>
                    </v-tabs>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            tab: null,
            items: [
                t('quality-control::nequas.fbc_results'),
                t('quality-control::nequas.adlc_results'),
                t('quality-control::nequas.px_results'),
            ],
            viewReportsModal: false,
            previewReportsModal: false,
            downloadingFile: false,
            columnsList: {
                fbcColumns: [
                    {
                        text: t('quality-control::nequas.grid.label.prn'),
                        value: 'prn',
                        width: 125,
                        sortable: true,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.sample_ref'),
                        value: 'sample_id',
                        width: 125,
                        sortable: true,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.created_at'),
                        value: 'date',
                        width: 150,
                        sortable: true,
                    },
                    {
                        text: t('quality-control::grid.label.pharmacy_site'),
                        value: 'pharmacy_site',
                        width: 150,
                        sortable: true,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.wbc'),
                        value: 'sample_properties.wbc',
                        fields: 'sample_properties',
                        width: 75,
                        sortable: false,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.rbc'),
                        value: 'sample_properties.rbc',
                        fields: 'sample_properties',
                        width: 75,
                        sortable: false,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.hgb'),
                        value: 'sample_properties.hgb',
                        fields: 'sample_properties',
                        width: 75,
                        sortable: false,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.hct'),
                        value: 'sample_properties.hct',
                        fields: 'sample_properties',
                        width: 75,
                        sortable: false,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.mcv'),
                        value: 'sample_properties.mcv',
                        fields: 'sample_properties',
                        width: 75,
                        sortable: false,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.mch'),
                        value: 'sample_properties.mch',
                        fields: 'sample_properties',
                        width: 75,
                        sortable: false,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.mchc'),
                        value: 'sample_properties.mchc',
                        fields: 'sample_properties',
                        width: 75,
                        sortable: false,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.platelet'),
                        value: 'sample_properties.plt',
                        fields: 'sample_properties',
                        width: 100,
                        sortable: false,
                        align: 'center',
                    },
                ],
                adlcColumns: [
                    {
                        text: t('quality-control::nequas.grid.label.prn'),
                        value: 'prn',
                        width: 125,
                        sortable: true,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.sample_ref'),
                        value: 'sample_id',
                        width: 125,
                        sortable: true,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.created_at'),
                        value: 'date',
                        width: 150,
                        sortable: true,
                    },
                    {
                        text: t('quality-control::grid.label.pharmacy_site'),
                        value: 'pharmacy_site',
                        width: 150,
                        sortable: true,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.wbc'),
                        value: 'sample_properties.wbc',
                        fields: 'sample_properties',
                        width: 75,
                        sortable: false,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.neut'),
                        value: 'sample_properties.neut',
                        fields: 'sample_properties',
                        width: 75,
                        sortable: false,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.lym'),
                        value: 'sample_properties.lym',
                        fields: 'sample_properties',
                        width: 75,
                        sortable: false,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.mono'),
                        value: 'sample_properties.mono',
                        fields: 'sample_properties',
                        width: 75,
                        sortable: false,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.eos'),
                        value: 'sample_properties.eos',
                        fields: 'sample_properties',
                        width: 75,
                        sortable: false,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.bas'),
                        value: 'sample_properties.bas',
                        fields: 'sample_properties',
                        width: 75,
                        sortable: false,
                        align: 'center',
                    },
                ],
                pxColumns: [
                    {
                        text: t('quality-control::nequas.grid.label.prn'),
                        value: 'prn',
                        width: 125,
                        sortable: true,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.sample_ref'),
                        value: 'sample_id',
                        width: 125,
                        sortable: true,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.created_at'),
                        value: 'date',
                        width: 150,
                        sortable: true,
                    },
                    {
                        text: t('quality-control::grid.label.pharmacy_site'),
                        value: 'pharmacy_site',
                        width: 150,
                        sortable: true,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.wbc'),
                        value: 'sample_properties.wbc',
                        fields: 'sample_properties',
                        width: 75,
                        sortable: false,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.rbc'),
                        value: 'sample_properties.rbc',
                        fields: 'sample_properties',
                        width: 75,
                        sortable: false,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.hgb'),
                        value: 'sample_properties.hgb',
                        fields: 'sample_properties',
                        width: 75,
                        sortable: false,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.hct'),
                        value: 'sample_properties.hct',
                        fields: 'sample_properties',
                        width: 75,
                        sortable: false,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.mcv'),
                        value: 'sample_properties.mcv',
                        fields: 'sample_properties',
                        width: 75,
                        sortable: false,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.mch'),
                        value: 'sample_properties.mch',
                        fields: 'sample_properties',
                        width: 75,
                        sortable: false,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.mchc'),
                        value: 'sample_properties.mchc',
                        fields: 'sample_properties',
                        width: 75,
                        sortable: false,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.rdw'),
                        value: 'sample_properties.rdw',
                        fields: 'sample_properties',
                        width: 75,
                        sortable: false,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.plt'),
                        value: 'sample_properties.plt',
                        fields: 'sample_properties',
                        width: 75,
                        sortable: false,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.mpv'),
                        value: 'sample_properties.mpv',
                        fields: 'sample_properties',
                        width: 75,
                        sortable: false,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.neut'),
                        value: 'sample_properties.neut',
                        fields: 'sample_properties',
                        width: 75,
                        sortable: false,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.lym'),
                        value: 'sample_properties.lym',
                        fields: 'sample_properties',
                        width: 75,
                        sortable: false,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.mono'),
                        value: 'sample_properties.mono',
                        fields: 'sample_properties',
                        width: 75,
                        sortable: false,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.eos'),
                        value: 'sample_properties.eos',
                        fields: 'sample_properties',
                        width: 75,
                        sortable: false,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.bas'),
                        value: 'sample_properties.bas',
                        fields: 'sample_properties',
                        width: 75,
                        sortable: false,
                        align: 'center',
                    },
                    {
                        text: t('quality-control::nequas.grid.label.neu%'),
                        value: 'sample_properties.neu%',
                        fields: 'sample_properties',
                        width: 75,
                        sortable: false,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.lym%'),
                        value: 'sample_properties.lym%',
                        fields: 'sample_properties',
                        width: 75,
                        sortable: false,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.mon%'),
                        value: 'sample_properties.mon%',
                        fields: 'sample_properties',
                        width: 75,
                        sortable: false,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.eos%'),
                        value: 'sample_properties.eos%',
                        fields: 'sample_properties',
                        width: 75,
                        sortable: false,
                    },
                    {
                        text: t('quality-control::nequas.grid.label.bas%'),
                        value: 'sample_properties.bas%',
                        fields: 'sample_properties',
                        width: 75,
                        sortable: false,
                    },
                ],
            },
            columns: [],
            gridItems: [],
        };
    },
    computed: {
        period() {
            return this.$store.state.qualityControl.neqas.period;
        },
        reports() {
            return this.$store.state.qualityControl.neqas.reports;
        },
        currentReport() {
            return this.$store.state.qualityControl.neqas.currentReport;
        },
        currentReportADLC() {
            return this.currentReport && this.currentReport.data && this.currentReport.data.data.adlc
                ? this.currentReport.data.data.adlc
                : [];
        },
        currentReportFBC() {
            return this.currentReport && this.currentReport.data && this.currentReport.data.data.fbc
                ? this.currentReport.data.data.fbc
                : [];
        },
        currentReportPX() {
            return this.currentReport && this.currentReport.data && this.currentReport.data.data.px
                ? this.currentReport.data.data.px
                : [];
        },
        currentFilters() {
            return this.$store.state.qualityControl.neqas.filters;
        },
    },
    watch: {
        tab(tab) {
            if (tab === 0) {
                this.columns = this.columnsList.fbcColumns;
                this.gridItems = this.currentReportFBC;
            }
            if (tab === 1) {
                this.columns = this.columnsList.adlcColumns;
                this.gridItems = this.currentReportADLC;
            }
            if (tab === 2) {
                this.columns = this.columnsList.pxColumns;
                this.gridItems = this.currentReportPX;
            }
        },
        viewReportsModal(modal) {
            this.$root.setAppOverLay(modal);
        },
        currentReport() {
            if (this.tab === 0) {
                this.gridItems = this.currentReportFBC;
            } else if (this.tab === 1) {
                this.gridItems = this.currentReportADLC;
            } else {
                this.gridItems = this.currentReportPX;
            }
        },
    },
    mounted() {
        this.columns = this.columnsList.fbcColumns;
        this.gridItems = this.currentReportFBC;
    },
    methods: {
        onClose() {
            this.tab = null;
            this.$store.dispatch('qualityControl/clearCurrentReport');
        },
        openReportsModal() {
            this.fetchReportsList();
            this.viewReportsModal = true;
        },
        previewReport(report) {
            this.$store.dispatch('qualityControl/fetchNeqasCurrentReport', report).then(() => {
                this.previewReportsModal = true;
            });
        },
        fetchReportsList(page = 1) {
            this.$store.dispatch('qualityControl/fetchNeqasReprots', { page });
        },
        downloadReport(report) {
            if (this.downloadingFile) {
                return;
            }

            this.downloadingFile = true;

            return axios
                .get(route('neqas-reports.download', { report: report.id }))
                .then((response) => {
                    const link = document.createElement('a');
                    link.href = response.request.responseURL;
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((error) => {
                    this.$root.notify(
                        'error',
                        t('quality-control::nequas.grid.generate.report.fail'),
                        error.response.data.error
                    );
                })
                .finally(() => {
                    _.delay(() => {
                        this.downloadingFile = false;
                    }, 2000);
                });
        },
    },
};
</script>
